module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"category":"Kategorie:","state":"Status:","constructed":"Erbaut:","demolished":"Abgerissen:","description":"Architektur","moreinfo":"Abrissgrund","comment":"Kommentar"},"fr":{},"en":{}}')
  delete Component.options._Ctor
}
